import { ActionReducer, INIT, UPDATE } from "@ngrx/store";
import { logoutAction } from "@state/actions/auth.actions";
import { AppState } from "src/app/app.state";
import { AppSettings } from "src/app/shared/Constants/sharedConstants";

//persist ngrx state store to session storage
export const sessionStorageReducer = (reducer: ActionReducer<AppState>): ActionReducer<AppState> => {
  //console.log('sessionStorageReducer');
  return (state, action) => {
    //console.log('sessionStorageReducer action.type', action.type);
    const nextState = reducer(state, action);

    //if the action is logout, clear the session storage
    if (action.type === logoutAction.type) {
      sessionStorage.removeItem('TapState');
      return nextState;
    }

    if ([INIT.toString(), UPDATE.toString()].includes(action.type)) {
      const savedState = sessionStorage.getItem('TapState');
      //console.log('sessionStorageReducer savedState', savedState);
      AppSettings.tapStateExisted = savedState ? true : false;
      return savedState ? JSON.parse(savedState) : nextState;
    }
    sessionStorage.setItem('TapState', JSON.stringify(nextState));
    //console.log('sessionStorageReducer nextState', nextState);
    return nextState;
  };
};
